module.exports = __webpack_public_path__ + "img/game-console-handheld.6fbad4ad.svg";